<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <statistics-form @load="onLoadDocs" @reset="onReset" @change:date:start="date = $event"/>
            </v-col>
            <template v-if="docs.length > 0">
                <!-- FIRST COLUMN -->
                <v-col cols="12" md="4">
                    <v-row>
                        <v-col cols="12">
                            <acute-chronic-chart :docs="lastWeeks"/>
                        </v-col>
                        <v-col cols="12">
                            <variables-chart :docs="docs" />
                        </v-col>
                    </v-row>
                </v-col>
                <!-- SECOND COLUMN -->
                <v-col cols="12" md="4">
                    <v-row>
                        <v-col cols="12">
                            <wellness-chart :docs="docs" />
                        </v-col>
                        <v-col cols="12">
                            <exercises-chart :docs="docs" :coach-id="coachId"/>
                        </v-col>
                    </v-row>
                </v-col>
                <!-- THIRD COLUMN -->
                <v-col cols="12" md="4">
                    <v-row>
                        <v-col cols="12">
                            <sessions-chart :docs="docs" :date="date" />
                        </v-col>
                        <v-col cols="12">
                            <last-weeks-chart :docs="lastWeeks" />
                        </v-col>
                    </v-row>
                </v-col>
            </template>
        </v-row>
    </v-container>
</template>

<script>

import StatisticsForm from "@/components/statistics/StatisticsForm";
import WellnessChart from "@/components/statistics/WellnessChart";
import SessionsChart from '../../components/statistics/SessionsChart.vue';
import VariablesChart from '../../components/statistics/VariablesChart.vue';
import LastWeeksChart from '../../components/statistics/LastWeeksChart.vue';
import ExercisesChart from '../../components/statistics/ExercisesChart.vue';
import { db } from '@/utils/Firebase'
import { getMergedBlocks } from '../../utils/Exercises';
import AcuteChronicChart from '../../components/statistics/AcuteChronicChart.vue';

export default {
    components: { WellnessChart, StatisticsForm, SessionsChart, VariablesChart, LastWeeksChart, ExercisesChart, AcuteChronicChart },
    data() {
        return {
            docs: [],
            date: null,
            lastWeeks: []
        }
    },
    computed: {
        coachId(vm = this) {
            return vm.account?.studentSubscription?.coachId || null
        },
        studentId(vm = this) {
            return vm.currentUser?.uid || null
        },
    },
    methods: {
        onLoadDocs(docs) {
            const vm = this
            vm.docs = docs
            vm.loadLastWeeks()
        },
        onReset() {
            const vm = this
            vm.docs = []
            vm.lastWeeks = []
        },
        async loadLastWeeks() {
            const vm = this;
            const endDate = vm.$moment().endOf('week');
            const startDate = vm.$moment(endDate).subtract(4, 'weeks').startOf('week');

            const routinesRef = await db.collection('assignedRoutines')
                .where('studentId', '==', vm.studentId)
                .where('rawDate.full', ">=", startDate.format('YYYY-MM-DD'))
                .where('rawDate.full', "<=", endDate.format('YYYY-MM-DD'))
                .orderBy('rawDate.full', 'asc').get()

            vm.lastWeeks = await Promise.all(
                routinesRef.docs.map(async doc => {
                    const blocks = await getMergedBlocks(doc.data().blocks || []);
                    return { ...doc.data(), id: doc.id, blocks: blocks };
                })
            );
        }
    },
    watch: {
        studentId(val) {
            if(val) this.loadLastWeeks()
        }
    }
}
</script>

<style scoped></style>